import { DiAngularSimple, DiCss3, DiGoogleCloudPlatform, DiHtml5, DiJavascript, DiJoomla, DiNodejsSmall, DiReact, DiWordpress } from 'react-icons/di'

import './chip.scss'

export type chipType = 'react' | 'node' | 'angular' | 'html' | 'scss' | 'css' | 'typescript' | 'joomla' | 'wordpress' | 'javascript' | 'googlecloud'

type ChipPorps = {
  type: chipType
}

const config = {
  react: { text: 'React', icon: <DiReact /> },
  node: { text: 'Node', icon: <DiNodejsSmall /> },
  angular: { text: 'Angular', icon: <DiAngularSimple /> },
  html: { text: 'HTML5', icon: <DiHtml5 />},
  css: { text: 'CSS', icon: <DiCss3 />},
  scss: { text: 'SCSS', icon: <DiCss3 />},
  typescript: { text: 'Typescript', icon: <div />},
  joomla: { text: 'Joomla', icon: <DiJoomla />},
  wordpress: { text: 'Wordpress', icon: <DiWordpress />},
  javascript: { text: 'Javascript', icon: <DiJavascript />},
  googlecloud: { text: 'Google Cloud', icon: <DiGoogleCloudPlatform /> },

}

function Chip(props: Readonly<ChipPorps>) {
  return (
    <div className='comp-chip'>
      {config[props.type].icon}
      <div className='chip-text '>{config[props.type].text}</div>
    </div>
  )
}

export default Chip
